import type { GridColumnVisibilityModel } from '@/ui/primitives';
import type { SuiteExecutionStatus } from '@flowqa/shared';

export type CloneSortDirection = 'asc' | 'desc';
export type CloneSortKey =
  | 'name'
  | 'latestExecutionTimestamp'
  | 'executionPassRate'
  | 'executionFrequencyPerDay'
  | 'executionAverageDurationMs'
  | 'executionPassRateDelta'
  | 'executionFrequencyPerDayDelta'
  | 'executionAverageDurationMsDelta';

export const cloneDefaultSortKey: CloneSortKey = 'name';
export const cloneDefaultSortDirection: CloneSortDirection = 'asc';

export const cloneSortOptions: Array<{ key: CloneSortKey; label: string }> = [
  { key: 'name', label: 'Suite' },
  { key: 'latestExecutionTimestamp', label: 'Latest' },
  { key: 'executionPassRate', label: 'Pass Rate' },
  { key: 'executionPassRateDelta', label: 'Pass Rate Delta' },
  { key: 'executionFrequencyPerDay', label: 'Frequency' },
  { key: 'executionFrequencyPerDayDelta', label: 'Frequency Delta' },
  { key: 'executionAverageDurationMs', label: 'Average Duration' },
  { key: 'executionAverageDurationMsDelta', label: 'Average Duration Delta' },
];

export const cloneSortFieldMap: Record<CloneSortKey, string> = {
  name: 'name',
  latestExecutionTimestamp: 'latestExecutionTimestamp',
  executionPassRate: 'executionPassRate',
  executionFrequencyPerDay: 'executionFrequencyPerDay',
  executionAverageDurationMs: 'executionAverageDurationMs',
  executionPassRateDelta: 'executionPassRateDelta',
  executionFrequencyPerDayDelta: 'executionFrequencyPerDayDelta',
  executionAverageDurationMsDelta: 'executionAverageDurationMsDelta',
};

export const cloneColumnOptions: Array<{ field: string; label: string; mandatory?: boolean }> = [
  { field: 'name', label: 'Suite', mandatory: true },
  { field: 'latestExecutionStatus', label: 'Latest Status' },
  { field: 'testLatestExecutionPassed', label: 'Latest Tests' },
  { field: 'executionStatusCounts', label: 'Executions' },
  { field: 'metricsSummary', label: 'Metrics' },
  { field: 'actions', label: 'Actions' },
];

export const cloneStatusOptions: Array<{ value: SuiteExecutionStatus; label: string }> = [
  { value: 'passed', label: 'Passed' },
  { value: 'failed', label: 'Failed' },
  { value: 'errored', label: 'Errored' },
  { value: 'skipped', label: 'Skipped' },
];

export const cloneDefaultColumnVisibilityModel: GridColumnVisibilityModel = {
  name: true,
  latestExecutionStatus: true,
  testLatestExecutionPassed: true,
  executionStatusCounts: true,
  metricsSummary: true,
  latestExecutionTimestamp: false,
  actions: true,
};
